import _ from 'lodash';
import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { currentHelpers } from '../../redirection/current';
import { DesktopContext } from '../../wrappers/DesktopWrapper';
import { pageHandlers, pageInitialState, pageReducer } from '../reducers/PageReducer';
import { PapsContext } from './PapsContext';
import { CurrentSettingsContext, HomeSettingsContext } from './SettingsDataContext';
import { usePageAreaSettings } from './useHelpers/usePageSettings';
import { useRenders } from './useHelpers/useRenders';

const allowUnsynced = true

export const PageContext = createContext();

const PageProvider = (props) => {

  useRenders('PageProvider', true, true)

  // ParentContext - not available 
  const { getPageSettings } = usePageAreaSettings()

  // desktopContext
  const desktopContext = useContext(DesktopContext)
  const { desktop_state } = desktopContext ?? {}
  const { selectedPage, selectedPageItem } = desktop_state ?? {}
  const fromDesktop = desktop_state ? true : false

  // papsContext
  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { view, viewKey, otherView, pathViews, landingView, pathName } = paps_state ?? {}

  const _view = fromDesktop ? selectedPage : view
  const _viewKey = fromDesktop ? selectedPageItem : viewKey

  // currentSettingsContext
  const currentSettingsContext = useContext(CurrentSettingsContext)
  const { currentSettings_state } = currentSettingsContext ?? {}
  const { settingsAreaProps } = currentSettings_state ?? {}
  const { settings_currentArea } = settingsAreaProps ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});

  // settingsContexts 
  const homeSettingsContext = useContext(HomeSettingsContext);

  // homeSettings
  const { homeSettings_state } = homeSettingsContext ?? {}
  const { homeSettings } = homeSettings_state ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { logging: logging_home, appUrls: homeAppUrls } = homeSettings_global ?? {}
  const { logging: logging_app } = global ?? {}
  const logging = { ...logging_home, ...logging_app }
  const { showAppSettings, showHomeSettings } = logging ?? {}

  // get the actual view for the page
  let trueView = (_viewKey || otherView) ? _view : _view + '_list'
  trueView = currentHelpers.getTrueView(pathViews, _view, trueView, landingView, _viewKey)

  //pageReducer
  const page_init = { homeAppUrls }
  const [page_state, page_dispatch] = useReducer(pageReducer, page_init, pageInitialState)
  const { pageSettings } = page_state ?? {}
  const { _pathName } = pageSettings ?? {}

  const page_handlers = useMemo(
    () => pageHandlers(page_dispatch),
    [page_dispatch]
  );

  const aspPropsReady = !_.isEmpty(settings_currentArea) && trueView ? true : false

  // get the page settings
  const { _pageSettings, aspProps } = useMemo(() => {
    return getPageSettings({ aspProps_alt: props?.aspProps_alt })
  }, [aspPropsReady, pathName, trueView, _viewKey])

  useEffect(() => {
    // loads the _pageSettings into state 
    page_handlers.handleAmmend_pageSettings(_pageSettings, aspProps)
    // appSettings_handlers.handleSet_endFetch()
  }, [_pageSettings]);

  const isSynced = _pathName === pathName ? true : false

  if (showHomeSettings) console.log('homeSettings_global', homeSettings_global)
  if (showAppSettings) console.log('aps_global', aps_global)

  const contextProvider = () => {

    const cp = {
      homeSettings_global,
      logging,
      page_handlers,
      page_state,
    }

    return <PageContext.Provider value={cp}>
      {props.children}
    </PageContext.Provider>
  }

  // return <div style={{ color: 'white' }}>SSS</div>

  return isSynced || allowUnsynced ? contextProvider() : <div></div>
}

export default PageProvider